import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { TierInfo, TierSliceInterface, UserTiers } from './tiers.interface';

const initialState: TierSliceInterface = {
  loading: true,
  data: null,
  meta: null,
  error: null,
  tiers: [],
  userTiers: null,
};

export const tiersSlice = createSlice({
  name: 'tiers',
  initialState,
  reducers: {
    setTier: (state, action: PayloadAction<TierInfo>) => {
      state.tiers = action.payload.tiers;
      state.userTiers = action.payload.userTiers;
      state.loading = false;
      state.error = null;
    },
    setTiersLoading(state) {
      state.loading = true;
    },
    setTiersError(state, action: PayloadAction<any>) {
      state.tiers = [];
      state.userTiers = null;

      state.loading = false;
      state.error = action.payload;
    },
    setUserTiers: (state, action: PayloadAction<UserTiers>) => {
      state.userTiers = action.payload;
    },
    resetUserTier: (state) => {
      state.tiers = initialState.tiers;
      state.userTiers = initialState.userTiers;
    },
  },
});

export const { setTier, setTiersLoading, setTiersError, setUserTiers, resetUserTier } = tiersSlice.actions;

export const tierLoadingState = (state: RootState) => state.tiers.loading;
export const tierState = (state: RootState) => state.tiers.tiers;

export const UserTierState = (state: RootState) => state.tiers.userTiers;

export default tiersSlice.reducer;
